/**
 * Paso8.js
 */

//Dependencies
import React, { Component, createRef } from 'react';
import { connect } from 'react-redux'
import axios from 'axios';
import $ from 'jquery';
import { onBoardingDigital } from '../../actions/actions';
import { setErrorMessage } from '../../actions/actions'
import Camara from './NuevaCamara';
import { Layout } from './layout/Layout';
import { IndicacionCamara } from './customModals/IndicacionCamara';

//material-ui
import Grid from '@material-ui/core/Grid';

//Assets
import face from '../../static/img/face.png';

//Services
import { processToken } from './services/tokenService';
import { processFlow } from './services/flowService';
import { storeUrlRiesgoNet } from './services/riesgoNetService';
import { processEstado, processIdClientAnalytics } from './services/pixelService';
import session from 'redux-persist/lib/storage/session';

// let tipoFlujo = sessionStorage.getItem('tipoflujo')




class Paso8 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            paso: 8,
            disabled: false
        }

        this.paso8 = this.paso8.bind(this);
        this.camaraRef = createRef();
        this.validateImageOperationVU = this.validateImageOperationVU.bind(this);
        this.validateFlow = this.validateFlow.bind(this);
        this.validateToken = this.validateToken.bind(this);
        this.setSiguientePaso = this.setSiguientePaso.bind(this);
    }

    componentWillMount() {
        this.validateFlow();
        this.validateToken();
        processIdClientAnalytics('paso-8')
        processEstado("gesto3");
    }

    componentDidMount() {
        $(".load").fadeOut(700);
    }

    validateFlow() {
        processFlow(this.props.history, this.state.paso);
    }

    validateToken() {
        processToken(this.props.history);
    }

    validateImageOperationVU(image) {
        const validateImageOperation = {
            imageType: 'SS',
        };
        let formData = new FormData();
        formData.append("file", image);
        formData.append('data', new Blob([JSON.stringify(validateImageOperation)], {
            type: "application/json"
        }));


        $(".load").fadeIn(700);
        axios({
            method: 'post',
            timeout: 60 * 4 * 1000,
            data: formData,
            url: localStorage.getItem('url') + '/api/vu/validateImageOperation'
        }).then(response => {
            /* GUILLERMO INICIA REFACTOR */
            if(response.data.code === "201"){
                $(".load").fadeOut(700);
                this.setSiguientePaso();
                return this.props.history.push('/tyc')
            }
            else{
                this.analizaTipoFlujo(response.data);
            }

            /* GUILLERMO FINALIZA REFACTOR */
            // if (response.data.code === "201") {
            //     $(".load").fadeOut(700);
            //     this.setSiguientePaso();
            //     return this.props.history.push('/tyc')
            // } else if (response.data.code === "202" && sessionStorage.getItem('tipoFlujo') != 'standalone') {
            //     console.log ("ENTRE AL OTR IF NO STANDALNE")
            //     storeUrlRiesgoNet(this.props.history).then(() => {
            //         this.props.history.push('/error-identidad')
            //     });
            // }else if(sessionStorage.getItem('tipoFlujo') == 'standalone'){
            //     console.log ("ENTRE A IF STANDALNE")
            //     storeUrlRiesgoNet(this.props.history).then(() => {
            //         this.props.history.push('/error-standalone')
            // });}
            //  else if (!response.data.tieneReintentos && sessionStorage.getItem('tipoFlujo') != 'standalone') {
            //     storeUrlRiesgoNet(this.props.history).then(() => {
            //         this.props.history.push('/sin-reintentos')
            //     });
            // }else if (!response.data.tieneReintentos && sessionStorage.getItem('tipoFlujo') == 'standalone') {
            //     storeUrlRiesgoNet(this.props.history).then(() => {
            //         this.props.history.push('/error-standalone')
            //     });
            // }
        }).catch(error => {
            /*GUILLERMO INICIA REFACTOR */
            if(error.response != null){
                if(error.response.status == 500){
                    switch(sessionStorage.getItem('tipoFlujo')){
                        case null:
                            storeUrlRiesgoNet(this.props.history).then(() => {
                                this.props.history.push('/error-resolucion')
                            });
                            break;
                        case 'standalone':
                            storeUrlRiesgoNet(this.props.history).then(() => {
                                this.props.history.push('/error-standalone')
                            });                        
                            break;
                        default:
                            storeUrlRiesgoNet(this.props.history).then(() => {
                                this.props.history.push('/error-servicio')
                            });
                        
                    }
                }
                else{
                    if (error.response.data){
                        this.props.dispatch(
                            setErrorMessage(error.response.data.message)
                        );
                    }
                    if(sessionStorage.getItem('tipoFlujo') == 'standalone'){
                        storeUrlRiesgoNet(this.props.history).then(() => {
                            this.props.history.push('/error-standalone')
                        });
                    }
                    else{
                        if(!error.response.data.tieneReintentos){
                            storeUrlRiesgoNet(this.props.history).then(() => {
                                this.props.history.push('/sin-reintentos')
                            });
                        }
                        else{
                            storeUrlRiesgoNet(this.props.history).then(() => {
                                this.props.history.push('/error-prueba-vida')
                            });
                        }

                    }

                }                
            }
            else{
                storeUrlRiesgoNet(this.props.history).then(() => {
                    this.props.history.push('/error-prueba-vida')
                });                
            }

            /*GUILLERMO FINALIZA REFACTOR*/
            // if  (error.response.status == 500 && sessionStorage.getItem('tipoFlujo') == null) {
            //     storeUrlRiesgoNet(this.props.history).then(() => {
            //         this.props.history.push('/error-resolucion')
            //     });
            // } else if (error.response.status == 500 && sessionStorage.getItem('tipoFlujo') != 'standalone') {
            //     storeUrlRiesgoNet(this.props.history).then(() => {
            //         this.props.history.push('/error-servicio')
            //     });
            // }else  if (error.response.status == 500 && sessionStorage.getItem('tipoFlujo') == 'standalone') {
            //     storeUrlRiesgoNet(this.props.history).then(() => {
            //         this.props.history.push('/error-standalone')
            //     });
            // } else {
            //     this.props.dispatch(
            //         setErrorMessage(error.response.data.message)
            //     );
            //     if (error.response.data && !error.response.data.tieneReintentos && sessionStorage.getItem('tipoFlujo') != 'standalone') {
            //         storeUrlRiesgoNet(this.props.history).then(() => {
            //             this.props.history.push('/sin-reintentos')
            //         });
            //     }else if (error.response.data && !error.response.data.tieneReintentos && sessionStorage.getItem('tipoFlujo') == 'standalone') {
            //         storeUrlRiesgoNet(this.props.history).then(() => {
            //             this.props.history.push('/error-standalone')
            //         });
            //     } else if (error.response.data.message == null) {
            //         if(sessionStorage.getItem('tipoFlujo') != 'standalone')
            //         storeUrlRiesgoNet(this.props.history).then(() => {
            //             this.props.history.push('/error-servicio')
            //         });
            //         else if(sessionStorage.getItem('tipoFlujo') == 'standalone')
            //         storeUrlRiesgoNet(this.props.history).then(() => {
            //             this.props.history.push('/error-standalone')
            //         });
            //     } else {
            //         storeUrlRiesgoNet(this.props.history).then(() => {
            //             this.props.history.push('/error-prueba-vida')
            //         });
            //     }
            // }
        })
    }

    analizaTipoFlujo(data) {
        if (sessionStorage.getItem('tipoFlujo') == 'standalone') {
            console.log("ENTRE A IF STANDALNE")
            storeUrlRiesgoNet(this.props.history).then(() => {
                this.props.history.push('/error-standalone')
            });
        }
        else {
            if (data.code === "202") {
                console.log("ENTRE AL OTR IF NO STANDALNE")
                storeUrlRiesgoNet(this.props.history).then(() => {
                    this.props.history.push('/error-identidad')
                });
            }
            else if (!data.tieneReintentos)
                storeUrlRiesgoNet(this.props.history).then(() => {
                    this.props.history.push('/sin-reintentos')
                });
        }
    }

    paso8() {
        this.setState({ disabled: true })
        //Exito, continuar al paso Sonrisa (que no exite)
        processIdClientAnalytics('sonrisa');
        //Manejo imperativo del hijo
        //Necesitamos que este scope de ejecución del onClick() se propague para poder abrir la camara.
        this.camaraRef.current.handleClick();
    }

    setSiguientePaso() {
        this.props.dispatch(
            onBoardingDigital(this.state.paso + 1)
        );
    }

    render() {
        const header = {
            progress: { value: 75 }
        };
        const footer = {
            button: {
                action: this.paso8,
                text: "Sacar Foto",
                disabled: this.state.disabled
            }
        };
        const mensaje = <React.Fragment>Para tomar la foto, asegurate de que la cámara quede en formato <b>vertical</b> y ubicá tu rostro en el centro de la pantalla</React.Fragment>;
        const body = {
            img: {
                src: face
            },
            slot: <IndicacionCamara vertical mensajePantalla={mensaje} />
        }
        return (
            <Layout header={header} footer={footer} body={body}
                tieneFooter>
                <Grid item xs={12} sm={12}>
                    <div className="content-description">
                        <h5 className="title" >Tomate una foto</h5>
                        <h5 className="title" >sonriendo. </h5>
                        <h6 className="description">Asegurate de que haya suficiente luz.</h6>
                    </div>
                </Grid>
                <Camara ref={this.camaraRef} parentHandleImage={this.validateImageOperationVU} capture='user' />
            </Layout>
        );
    }
}

export default connect()(Paso8);


// WEBPACK FOOTER //
// ./src/components/OnBoarding/Paso8.js